import clsx from "clsx";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { SubscriptionPaymentMethod } from "features/payment-methods/components";

import { Dialog, DialogContent } from "common/components/ui/Dialog";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import Features from "./Features";
import Footer from "./Footer";
import Heading from "./Heading";

import WelcomeScreenDesktop from "assets/images/welcome-screen-desktop.webp";
import WelcomeScreenMobile from "assets/images/welcome-screen-mobile.webp";

const queryParam = "welcome-screen";

export default function WelcomeScreen() {
  const isDesktop = useTwBreakpoint("lg");
  const { subscription } = useSelectedWorkspaceContext();
  const [currentStep, setCurrentStep] = useState<"default" | "payment">(
    "default",
  );

  const [searchParams, setSearchParams] = useSearchParams();
  const isWelcomeScreenOpen = !!searchParams.get(queryParam);

  function closeDialog() {
    setSearchParams((prevParams) => {
      const params = new URLSearchParams(prevParams);
      params.delete(queryParam);
      return params;
    });
  }

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;

  return (
    <Component open={isWelcomeScreenOpen} dismissible={false}>
      <Content
        className={clsx(
          "[&>#close-button]:hidden",
          currentStep === "default" && "lg:p-1.5",
        )}
        size={currentStep === "default" ? "xl" : "md"}
      >
        {currentStep === "payment" ? (
          <SubscriptionPaymentMethod
            subscriptionId={subscription.id}
            onBack={() => setCurrentStep("default")}
            onSuccess={closeDialog}
            mixpanelSource="onboarding"
          />
        ) : (
          <div className="lg:border lg:border-black-200 w-full max-w-[400px] lg:max-w-full mx-auto lg:overflow-y-auto lg:scrollbar-thin lg:rounded-3xl">
            <img
              src={WelcomeScreenDesktop}
              alt=""
              className="rounded-3xl mb-6 max-lg:hidden w-full object-cover"
            />

            <div className="flex flex-col lg:flex-row gap-3 lg:gap-20 lg:w-[740px] mx-auto">
              <Heading />
              <Features />
            </div>

            <img
              src={WelcomeScreenMobile}
              alt=""
              className="rounded-5xl mb-4 mt-8 lg:hidden mx-auto"
            />

            <Footer
              onClose={closeDialog}
              onAddPaymentMethod={() => setCurrentStep("payment")}
            />
          </div>
        )}
      </Content>
    </Component>
  );
}
